export const services = [
  {
    icons: "/icons/service1.png",
    title: "Ticket Booking",
    details:
      "We book all kind of national or international ticket for your destinaion.",
  },
  {
    icons: "/icons/service2.png",
    title: "Hotel Booking",
    details:
      "You can easily book your according to your budget hotel by our website.",
  },
  {
    icons: "/icons/service3.png",
    title: " Tour Plan",
    details: "We provide you the best plan within a short time explore more.",
  },
];

export const otherServices = [
  {
    icons: "/icons/m1.png",
    numbers: "15+",
    info: "Years of Experience",
  },
  {
    icons: "/icons/m2.png",
    numbers: "15k+",
    info: "Happy Travellers",
  },
  {
    icons: "/icons/m3.png",
    numbers: "650+",
    info: "Places Visited",
  },
  {
    icons: "/icons/m4.png",
    numbers: "2k+",
    info: "Travel History",
  },
];

export const destination = [
  {
    image: "/images/d1.png",
    city: "Thailand",
    activities: "20+ Spots",
    rating: "2D & 3N",
    icon: "/icons/arrow.png",
  },
  {
    image: "/images/d2.png",
    city: "Indonesia",
    activities: "25+ Spots",
    rating: "3D & 3N",
    icon: "/icons/arrow.png",
  },
  {
    image: "/images/d3.png",
    city: "New Zeland",
    activities: "20+ Spots",
    rating: "3D & 2N",
    icon: "/icons/arrow.png",
  },
];
export const button = [
  {
    content: "Hot Deals",
  },
  {
    content: "BackPack",
  },
  {
    content: "South Asia",
  },
  {
    content: "Honeymoon",
  },
  {
    content: "Europe",
  },
  {
    content: "More",
  },
];

export const packages = [
  {
    image: "/images/p1.png",
    days: "3 Days, 2 Nights",
    price: "$500 / Person",
    details: "Explore the Beauty of the island  with our travel agency.",
    icon: "/icons/location.png",
    place: "Indonesia",
    more: "Know more",
  },
  {
    image: "/images/p2.png",
    days: "3 Days, 2 Nights",
    price: "$800 / Person",
    details: "Enjoy the Shrimes and blossoms here in this beautiful country.",
    icon: "/icons/location.png",
    place: "Japan",
    more: "Know more",
  },
  {
    image: "/images/p3.png",
    days: "3 Days, 2 Nights",
    price: "$600 / Person",
    details: "Explore the majestic mountains and landscapes day and nights.",
    icon: "/icons/location.png",
    place: "Mountains",
    more: "Know more",
  },
];

export const steps = [
  {
    icon: "/icons/n1.png",
    title: "Choose Destination",
    info: "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Urna, tortor tempus. ",
  },
  {
    icon: "/icons/n2.png",
    title: "Make Payment",
    info: "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Urna, tortor tempus. ",
  },
  {
    icon: "/icons/n3.png",
    title: "Reach Airport on Selected Date",
    info: "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Urna, tortor tempus. ",
  },
];
